import { API, HTTPMethod, ContentType } from './APICentral';
import { APIEncoder } from './APIEncoder';

const documentApiRoutes = {
    lineSchedule: "document/line/",
    lineScheduleDownload: "document/download/line/",
};

export class DocumentAPI {
    static getLineScheduleDocument(id) {
        const url = `${documentApiRoutes.lineSchedule}${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            key: APIEncoder.getApiKey()
        });
    }

    static getLineDirectionScheduleDocument(code, direction) {
        const url = `${documentApiRoutes.lineSchedule}${code}/${direction}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            key: APIEncoder.getApiKey()
        });
    }

    static downloadLineScheduleDocument(document) {
        const url = `${documentApiRoutes.lineScheduleDownload}${document}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            key: APIEncoder.getApiKey()
        }, false);
    }
}